<template>
  <Modal v-model="visible" title="添加题目模板">
    <Form class="form" :rules="Rules" ref="createTemplateForm" :model="createTemplateParams">
      <Row>
        <FormItem :label-width="90" label="模板名称" prop='name'>
          <Input v-model="createTemplateParams.name" placeholder="请输入活动名称用于列表展示"></Input>
        </FormItem>
        <FormItem :label-width="90" label="题目大类" prop='type'>
          <Select v-model="createTemplateParams.type" clearable>
            <Option value="video" key="1">录音题</Option>
            <Option value="read" key="2">阅读理解</Option>
            <Option value="listen" key="3">听力题</Option>
          </Select>
        </FormItem>
        <FormItem :label-width="90" label="模板英文">
          <Input v-model="createTemplateParams.english" type="textarea" :rows="4" placeholder="请输入模板英文"></Input>
        </FormItem>
      </Row>
    </Form>
    <div slot="footer">
        <Button type="text" size="large" @click="visible = false">取消</Button>
        <Button type="primary" size="large" @click="createTemplate">确定</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  name: 'CreateTemplateModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    successCallback: {
      type: Function
    }
  },
  data(){
    return {
      visible: this.value,
      createTemplateParams: {

      },
      Rules: {
        name: [
          { type: 'string', required: true, message: '请输入模板名称', trigger: 'blur' },
          { pattern: /^[\u4E00-\u9FA5A-Za-z0-9]{2,20}$/, message: '只能输入中文、英文和数字', trigger: 'blur'}
        ],
        type: [
          { required: true, message: '选择海报分类', trigger: 'blur' }
        ],
      }
    }
  },
  methods: {
    createTemplate(){
      let self = this
      self.$refs.createTemplateForm.validate((valid) => {
        if(!valid) {
          self.$message.waring('信息输入错误！')
          return
        }
        self.$http.post('', self.createTemplateParams).then(res => {
          if(res){

          }
        }).catch(err => {
          self.$message.error(err)
        })
      })
    }
  },
  watch: {
    value(val){
      this.visible = val
    },
    visible(val){
      if(val === true){

      }
    }
  }

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// CreateTemplateModal.vue?2c179650